"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 15
    },
    filesInfo: {
        display: 'flex',
        fontWeight: 'normal',
        fontSize: 12,
        lineHeight: '15px'
    },
    errorsCount: {
        display: 'inline-flex',
        paddingRight: 10,
        color: theme.warningRed,
        '& span:last-child': {
            paddingLeft: 3
        }
    },
    filesCount: {
        display: 'inline-flex',
        width: '100%',
        color: theme.grey3,
        '& span:last-child': {
            paddingLeft: 3
        }
    }
});
//# sourceMappingURL=label.style.js.map